export const GLOBAL_STATE = 'Conference'

export const CONFERENCE = 'CONFERENCE' as const
export const CONFERENCE_CREATE = 'CONFERENCE_CREATE' as const
export const CONFERENCE_ALL = 'CONFERENCE_ALL' as const
export const CONFERENCE_ALL_FILTER = 'CONFERENCE_ALL_FILTER' as const
export const CONFERENCE_ARTICLE_LIST = 'CONFERENCE_ARTICLE_LIST' as const
export const CONFERENCE_ARTICLE = 'CONFERENCE_ARTICLE' as const
export const CONFERENCE_ARTICLE_ALL = 'CONFERENCE_ARTICLE_ALL' as const
export const CONFERENCE_MAGAZINE_ARTICLE = 'CONFERENCE_MAGAZINE_ARTICLE' as const
export const CONFERENCE_ARTICLE_STEP = 'CONFERENCE_ARTICLE_STEP' as const
export const CONFERENCE_ARTICLE_PROOF = 'CONFERENCE_ARTICLE_PROOF' as const
export const CONFERENCE_CATEGORY_ALL = 'CONFERENCE_CATEGORY_ALL' as const
